<template>
  <header class="header">
   <div class="container" style="max-width: 960px">
      <nav class="navbar navbar-light  bg-inverse navbar-expand-lg">
        <span class="navbar-brand d-lg-none d-md-block d-block">
          <img src="../assets/logo.png" class="logo" />
        </span>
        <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
             <li class="nav-item d-none d-lg-inline-block">
              <img src="../assets/logo.png" class="logo"/>
            </li>
            <li class="nav-item active">
              <router-link to="/" class="nav-link active" exact>Inicio</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/menu" class="nav-link">Menú</router-link>
            </li>
           
            <!-- <li class="nav-item">
              <a href="https://carta.eiensushi.cl" target="_blank" class="nav-link">Carta</a>
            </li> -->
            <!-- <li class="nav-item">
              <router-link to="/ubicacion" class="nav-link">Ubicación</router-link>
            </li> -->
            <!-- <li class="nav-item">
              <router-link to="/pedidos" class="nav-link">Pedidos</router-link>
            </li> -->
            <li class="nav-item">
              <a href="https://chiguayante.eiensushi.cl" target="_blank" class="nav-link">Pedidos</a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </header>
  
</template>

<script>
export default {
  mounted() {
    var buttons = document.querySelectorAll('.nav-link')
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function() {
          document.querySelector('#navbarSupportedContent').classList.remove('show')
      });
    }
  }
}
</script>

<style scoped>
ul li a, a.nav-link {
  font-family: 'Montserrat';
  text-transform: uppercase;
  font-weight: bold;
  color: black !important;
  position: relative;
  text-align: center;
  min-width: 150px;
}
a.nav-link::after{
  content: '';
  display: none;
  bottom: 15px;
  width: 95%;
  right: 3px;
  left: 3px;
  height: 5px;
  position: absolute;
  background: #cd0e15;

  -webkit-animation: fadeInFromNone 0.8s ease-out;
  -moz-animation: fadeInFromNone 0.8s ease-out;
  -o-animation: fadeInFromNone 0.8s ease-out;
  animation: fadeInFromNone 0.8s ease-out;
}

@-webkit-keyframes fadeInFromNone {
  0% {
    display: none;
    opacity: 0;
  }

  1% {
    display: block;
    opacity: 0;
  }

  100% {
    display: block;
    opacity: 1;
  }
}

@-moz-keyframes fadeInFromNone {
  0% {
    display: none;
    opacity: 0;
  }

  1% {
    display: block;
    opacity: 0;
  }

  100% {
    display: block;
    opacity: 1;
  }
}

@-o-keyframes fadeInFromNone {
  0% {
    display: none;
    opacity: 0;
  }

  1% {
    display: block;
    opacity: 0;
  }

  100% {
    display: block;
    opacity: 1;
  }
}

@keyframes fadeInFromNone {
  0% {
    display: none;
    opacity: 0;
  }

  1% {
    display: block;
    opacity: 0;
  }

  100% {
    display: block;
    opacity: 1;
  }
}

a.nav-link:hover::after, a.router-link-active::after, a.router-link-exact-active::after {
  display: block;
}

.logo {
  max-width: 140px;
}
.header {
  background: white;
  height: 120px;
  line-height: 85px;
}
@media only screen and (max-width: 970px) {
  .navbar-brand {
    width: 70%;
    display: inline-block;
  }
  .logo {
    max-width: 100%;
    /* width: auto; */
    max-height: 80px;
  }
  .navbar-toggler {
    position: absolute;
    right: 10px;
    top: 35px;
    outline: 1px solid #cacaca;
  }
  .justify-content-center {
    -ms-flex-pack: start !important;
    -webkit-box-pack: start !important;
    justify-content: start !important; 
  }
  .navbar-collapse {
    z-index: 99999;
    background: #ffff;
    border: 1px solid #cacaca;
    border-top: 0px;
  }
  .nav-item a.nav-link {
    width: 100%;
    padding: 3px 0px;
    line-height: 40px
  }
  a.nav-link::after {
    bottom: 0px !important;
    width: 100%;
    left: 0;
  }
}
</style>